"use strict";

angular.module("models").service("SyncHistoriesService", ["ApiService", function (ApiService) {
  var that = this;

  angular.extend(that, ApiService.getModel("SyncHistories", ["name"], function (element) {
    return "???";
  }));
}]);